import React, { useState, useEffect, useCallback } from "react";
import { getAccessToken } from "../../services/authApi";
import DocumentFileViewer from "../conditions/DocumentFileViewer";
import "./Documents.css";

const Documents = () => {
  const [loanId, setLoanId] = useState("");

  useEffect(() => {
    if (window.elli && window.elli.script && window.elli.script.guest) {
      try {
        window.elli.script.guest.create();
        window.elli.script
          .getObject("loan")
          .then((loanObject) =>
            loanObject.all().then((raw) => {
              const loan = raw?.loan ?? raw;
              const id = loan?.id;
              if (id) setLoanId(id);
            })
          );
      } catch (err) {
        console.error("Error initializing Encompass context:", err);
      }
    }
  }, []);

  const getToken = useCallback(async () => {
    const authObj = await window.elli.script.getObject("auth");
    const authCode = await authObj.createAuthCode();
    const token = await getAccessToken(authCode);
    if (!token) throw new Error("Unable to acquire access token");
    return token;
  }, []);

  return (
    <div className="docs-container">
      <div className="docs-header">
        <h1>Documents</h1>
        <p>Manage all documents associated with your loan.</p>
      </div>

      {/* Document File Viewer */}
      <section className="docs-viewer">
        <DocumentFileViewer loanId={loanId} getToken={getToken} />
      </section>
    </div>
  );
};

export default Documents;
